import * as logbookMonitoringReportUrl from 'src/helpers/url_helper';
import { apiSlice } from 'src/rtk/api/apiSlice';

export const logbookMonitoringReportApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['MonitoringReports'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getReportList: builder.query<APIResponse<any>, string>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_REPORT_LIST}?${url}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getScheduleListForExaminer: builder.query<APIResponseWithPagination<any>, any>({
        query: () => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_INTERVIEW_SCHEDULE_LIST_FOR_EXMAINER}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getScheduleListForItmc: builder.query<APIResponseWithPagination<any>, any>({
        query: () => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.SCHEDULE_LIST_FOR_ITMC_MEMBER}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getEvaluatedTraineeList: builder.query<APIResponse<any>, string>({
        query: (url) => ({
          method: 'GET',            
          url: `${logbookMonitoringReportUrl.EVALUATED_TRAINEE_LIST}?${url}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getImageData: builder.query<Blob, string>({
        query: (filepath: string) => ({
          url: `${logbookMonitoringReportUrl.GET_IMAGE}?filepath=${filepath}`,
          method: 'GET',
          responseHandler: (response: any) => response.blob(), // 👈 IMPORTANT
          // Optional: You can disable caching if needed
          // cache: 'no-cache',
        }),
        serializeQueryArgs: ({ queryArgs }) => queryArgs,
        keepUnusedDataFor: 0, // optional to avoid storing large Blobs unnecessarily
      }),

      getSuspiciousEntryList: builder.query<APIResponseWithPagination<SuspiciousEntryList>, string>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_SUSPICIOUS_ENTRY_LIST}?${url}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getSuspiciousEntryDetails: builder.query<APIResponse<any>, any>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_SUSPICIOUS_ENTRY_DETAILS}/${url.id}/${url.date}?${url.queryUrl}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getSupervisorSuspiciousApprovalList: builder.query<APIResponseWithPagination<SuspiciousEntryList>, string>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_SUPERVISOR_SUSPICIOUS_APPROVAL_LIST}?${url}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getSupervisorSuspiciousApprovalDetails: builder.query<APIResponse<any>, any>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_SUPERVISOR_SUSPICIOUS_APPROVAL_DETAILS}/${url.id}/${url.date}?${url.queryUrl}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getSixMonthlyReportData: builder.query<APIResponse<any>, any>({
        query: (url: any) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_SIX_MONTHLY_REPORT_DATA}/${url?.userId}?session_id=${url?.sessionId}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      getProgressReportData: builder.query<APIResponse<any>, any>({
        query: (url: any) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.GET_PROGRESS_REPORT_DATA}/${url?.regNo}/${url?.trainingId}`,
        }),
        providesTags: ['MonitoringReports'],
      }),

      createProgressReportEntry: builder.mutation<APIResponse<any>, any>({
        query: (data: any) => ({
          url: `${logbookMonitoringReportUrl.CREATE_PROGRESS_REPORT_ENTRY}`,
          method: 'POST',
          body: data,
          Headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['MonitoringReports'],
      }),

      createInterviewSchedule: builder.mutation<APIResponse<any>, any>({
        query: (data: any) => ({
          url: `${logbookMonitoringReportUrl.CREATE_INTERVIEW_SCHEDULE}`,
          method: 'POST',
          body: data,
          Headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['MonitoringReports'],
      }),

      createProgressReportInterviewAssesment: builder.mutation<APIResponse<any>, any>({
        query: (data: any) => ({
          url: `${logbookMonitoringReportUrl.PROGRESS_REPORT_INTERVIEW_ASSESSMENT}`,
          method: 'POST',
          body: data,
          Headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['MonitoringReports'],
      }),

      getProgressReportAssessmentApproval: builder.mutation<APIResponse<any>, string>({
        query: (url) => ({
          method: 'GET',
          url: `${logbookMonitoringReportUrl.PROGRESS_REPORT_ASSESSMENT_APPROVAL}/${url}`,
        }),
        invalidatesTags: ['MonitoringReports'],
      }),

      deleteSchedule: builder.mutation<APIResponse<any>, string>({
        query: (url) => ({
          method: 'DELETE',
          url: `${logbookMonitoringReportUrl.SCHEDULE_DELETE}/${url}`,
        }),
        invalidatesTags: ['MonitoringReports'],
      }),
      
    }),
  });

export const {
  useGetReportListQuery,
  useLazyGetImageDataQuery,
  useGetSuspiciousEntryListQuery,
  useGetSuspiciousEntryDetailsQuery,
  useGetSupervisorSuspiciousApprovalListQuery,
  useGetSupervisorSuspiciousApprovalDetailsQuery,
  useLazyGetSixMonthlyReportDataQuery,
  useLazyGetProgressReportDataQuery,
  useGetProgressReportDataQuery,
  useCreateProgressReportEntryMutation,
  useLazyGetEvaluatedTraineeListQuery,
  useCreateInterviewScheduleMutation,
  useGetScheduleListForExaminerQuery,
  useCreateProgressReportInterviewAssesmentMutation,
  useGetScheduleListForItmcQuery,
  useGetProgressReportAssessmentApprovalMutation,
  useDeleteScheduleMutation,
} = logbookMonitoringReportApi;
